import { Beaker, Landmark, Coins, Users, Shield } from "lucide-react";

export const SITDOWN_FORM_URL = "https://forms.gle/6zaAyyGb2bumdYN67";

// Mirrors the live Google Form "Policy, Science & Governance Deep Dives".
const FORM_BASE =
  "https://docs.google.com/forms/d/e/1FAIpQLSczDanKUsp5p4XXAIdq9r0TP4VdDsPDLIP86Y8rxZoBO_uHEg/viewform";
const CATEGORY_ENTRY = "entry.819877321";

export const SITDOWN_PILLARS = [
  {
    key: "science",
    Icon: Beaker,
    title: "Science, Technology & Evidence-Based Policy",
    short: "Science & Tech",
    tagline: "How agencies use — or politicize — data.",
    entry: "entry.1546240250",
    topics: [
      "Scientific Integrity & Regulatory Policy (How agencies use or politicize data, peer review, and technical consensus)",
      "Artificial Intelligence & Autonomous Systems (Algorithmic governance, data rights, and federal R&D priorities)",
      "Energy Transition & Applied Science (Grid reliability, nuclear development, and engineering realities of renewables)",
      "Biotechnology & Genetic Engineering (Ethics, legal guardrails for gene-editing/CRISPR, and pharma patent models)",
    ],
  },
  {
    key: "economy",
    Icon: Coins,
    title: "The Economy and Public Finance",
    short: "Economy",
    tagline: "Follow the receipts, not the talking points.",
    entry: "entry.1861457710",
    topics: [
      "Taxes and Public Spending (Auditing federal, state, and local revenues vs. debt growth and discretionary budgets)",
      "Jobs, Real Inflation & Household Purchasing Power (Cost of living, wage dynamics, market monopolies, and tariffs)",
      "Campaign Finance & Money in Politics (Super PAC influence, campaign contributions, and legislative voting records)",
    ],
  },
  {
    key: "social",
    Icon: Users,
    title: "Social and Cultural Policy",
    short: "Social Policy",
    tagline: "Healthcare, schools, and rights — by the numbers.",
    entry: "entry.1241597298",
    topics: [
      "Healthcare Access, Quality & Costs (Drug pricing transparency, public options vs. private insurance, and hospital monopolies)",
      "Education Policy & Funding (Public school funding models, school choice, curriculum standards, and vocational pipelines)",
      "Civil Rights, Equal Protection & Law (Equal protection, reproductive policy, criminal justice reform, and immigration enforcement)",
    ],
  },
  {
    key: "governance",
    Icon: Landmark,
    title: "Governance, Law and the Structure of Government",
    short: "Governance & Law",
    tagline: "Who holds the power, and who checks it.",
    entry: "entry.1819145366",
    topics: [
      "Federalism & Balance of Power (Federal mandates vs. state/local authority, executive orders, and agency rule-making)",
      "Judicial Appointments & Legal Interpretation (Originalism vs. living constitutionalism, nationwide injunctions, and court review limits)",
      "Elections, Voting & Political Process (Voter access laws, ballot security, gerrymandering, and ranked-choice voting)",
      "Ethics & Government Accountability (Stock trading by elected officials, revolving-door lobbying, and public transparency)",
    ],
  },
  {
    key: "defense",
    Icon: Shield,
    title: "Foreign Policy, Defense and Security",
    short: "Defense & Foreign Policy",
    tagline: "Budgets, treaties, and supply chains under audit.",
    entry: "entry.833885330",
    topics: [
      "Defense Budgets & Strategic Priorities (DoD audit findings, military readiness, advanced weapons systems, and foreign aid)",
      "Global Diplomacy & International Treaties (Trade alliances, defense treaties like NATO, and international conflict de-escalation)",
      "Resource Security & Supply Chains (Securing critical minerals, domestic water rights, and protecting agriculture/infrastructure from foreign ownership)",
    ],
  },
];

/** Short label (text before the parenthetical) for compact display. */
export const topicLabel = (t) => t.replace(/\s*\(.*\)\s*$/, "");

export const buildSitDownUrl = (pillar, topics = []) => {
  if (!pillar) return SITDOWN_FORM_URL;
  const params = new URLSearchParams({ usp: "pp_url" });
  params.set(CATEGORY_ENTRY, pillar.title);
  topics.forEach((t) => params.append(pillar.entry, t));
  return `${FORM_BASE}?${params.toString()}`;
};
